import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { CantinaService } from 'src/app/_servizi/cantina.service';

@Component({
  selector: 'app-tipi-visite-layout-colonne',
  templateUrl: './tipi-visite-layout-colonne.component.html',
  styleUrls: ['./tipi-visite-layout-colonne.component.css']
})
export class TipivisitaLayoutColonneComponent implements OnInit, OnChanges {

  get colori() {
    return this.appoggioService.getColoriIframe();
  }

  constructor(
    private cantinaService: CantinaService,
    private appoggioService: AppoggioService
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.tipivisiteFiltered = this.tipivisite;
    if (!this.base && this.collegate) {
      this.codiceFormMaster = this.codiceForm;
    } else {
      if (!this.collegate) {
        this.codiceFormMaster = null;
      }
    }
  }

  ngOnInit(): void {
  }

  @Input() codiceForm: any;
  @Input() codiceFormMaster: any;

  @Input() linguaCorrente: string;
  @Input() tipivisite: any;
  @Input() canBack: any;
  @Input() cart: boolean;
  @Input() base: boolean;
  @Input() collegate: boolean;

  @Output() goBack = new EventEmitter<any>();

  tipovisita: any = null;
  tipivisiteFiltered = [];
  backFilters = false;

  idxSelezionato = null;

  tornaIndietro() {
    if (!this.base) {
      if (this.backFilters) {
        this.tipivisiteFiltered = this.tipivisite;
        this.canBack = false;
        const idx = this.cantinaService.getIdxTvSelezionato();
        if (idx) {
          this.scrollTO('tipovisita__' + idx);
        }
      } else {
        this.goBack.emit();
      }
    } else {
      this.goBack.emit();
    }
  }

  lastStepClicked(values) {
    // this.tipivisiteFiltered = this.tipivisite.filter(tipovisita => tipovisita.id == values.id);
    this.cantinaService.setIdxTvSelezionato(values.idx);
    this.idxSelezionato = values.idx;
    this.canBack = true;
    this.backFilters = true;
    // this.scrollTO('tipiWrapperID');
  }

  scrollTO(target) {
    setTimeout(() => {
      document.getElementById(target).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, 200);
  }
}
